import { FilterProps } from "../filter-definition";
import { RadioButtonDateFilter } from "../GenericFilters/RadioButtonDateFilter";
import invoicesDefaultFilters from "./invoices-default-filters";

export const InvoiceDateFilter = (props: FilterProps) => (
  <RadioButtonDateFilter
    {...props}
    filterKey="invoiceDate"
    name="Invoice Date"
    defaultFilterType={invoicesDefaultFilters.invoiceDateType}
    defaultStartDate={invoicesDefaultFilters.invoiceDateStartDate}
    defaultEndDate={invoicesDefaultFilters.invoiceDateEndDate}
  />
);
